//import React from 'react';
//import { useState } from 'react';
import { Entity } from '@backstage/catalog-model';
import { useEntity, catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import {
//    RELATION_API_CONSUMED_BY,
//    RELATION_API_PROVIDED_BY,
    RELATION_CHILD_OF,
//    RELATION_CONSUMES_API,
    RELATION_DEPENDENCY_OF,
    RELATION_DEPENDS_ON,
//    RELATION_HAS_MEMBER,
    RELATION_HAS_PART,
    RELATION_MEMBER_OF,
    RELATION_OWNED_BY,
//    RELATION_OWNER_OF,
    RELATION_PARENT_OF,
//    RELATION_PART_OF,
    RELATION_PROVIDES_API,
  } from '@backstage/catalog-model';

export type EntityFilterCallback = (entity: Entity) => boolean;

export const WALK_ENTITY_CHILDREN = [
    RELATION_OWNED_BY,
    RELATION_DEPENDS_ON,
    RELATION_PARENT_OF,
    RELATION_MEMBER_OF,
    RELATION_HAS_PART,
    RELATION_PROVIDES_API,
];

export const WALK_ENTITY_PARENTS = [   
    RELATION_CHILD_OF, 
    RELATION_HAS_PART, 
    RELATION_MEMBER_OF, 
    RELATION_OWNED_BY, 
    RELATION_DEPENDENCY_OF,
    RELATION_PARENT_OF,
];

/*
function getRelationshipType(type: string) {
    switch (type) {
        case RELATION_OWNED_BY: return -1;
        case RELATION_DEPENDENCY_OF: return -1;
        case RELATION_PARENT_OF: return -1;
        case RELATION_MEMBER_OF: return -1;
        case RELATION_HAS_PART: return -1;

        case RELATION_OWNER_OF: return 1;
        case RELATION_DEPENDS_ON: return 1;
        case RELATION_CHILD_OF: return 1;
        case RELATION_HAS_MEMBER: return 1;
        case RELATION_PART_OF: return 1;        

        case RELATION_API_CONSUMED_BY: return 0;
        case RELATION_API_PROVIDED_BY: return 0;
        case RELATION_CONSUMES_API: return 0;
        case RELATION_PROVIDES_API: return 0;
        default: return 0;
    }    
}
*/

async function populateEntityMap(entity: Entity, catalogApi: any, relationships: string[], depth: number, entityMap: any) {

//console.log("populateEntityMap:", entity, relationships, depth, entityMap);

    if ( entity === undefined || 
         entity.metadata === undefined || 
         entity.metadata.uid === undefined || 
         entity.metadata.uid in entityMap || 
         depth <= 0) {   
        return; //we already looked at this one
    }

    let refs :string[] = [];

    entity && entity.relations && entity.relations.forEach(relation => {        
        //console.log("relation:", relation.type);

        if( relationships.includes(relation.type) ){
            refs.push(relation.targetRef);
        }
    });

    if (refs.length == 0) { return; }
//console.log("entity.relations:", entity.relations);
//console.log("refs:", refs);

    let result = await catalogApi.getEntitiesByRefs({ entityRefs: refs });
//console.log("result:", result);

    for(let i = 0; i < result.items.length; i++) {
        const element = result.items[i];
        if(element === undefined) { continue; }
//console.log("element:", element);

        await populateEntityMap(element, catalogApi, relationships, depth - 1, entityMap);
        entityMap[element.metadata.uid] = element;
    }
}

async function findEntityChildren(entity: Entity, catalogApi: any, filter: EntityFilterCallback) {
    let objectMap = {};

    await populateEntityMap(entity, catalogApi, WALK_ENTITY_CHILDREN, 10, objectMap);
    const values = Object.values(objectMap);
    const results = values.filter( (item) => filter(item as Entity) );
    
    /*
    console.log("------------------------");
    console.log("------------------------");
    console.log(objectMap);
    console.log(values);
    console.log(results);
    console.log("------------------------");
    console.log("------------------------");
    */

    return results;
}

export function useFilteredEntityChildren(filter: EntityFilterCallback) {
    //const [filteredEntityChildren, setFilteredEntityChildren] = useState([]);
    const catalogApi = useApi(catalogApiRef);
    const { entity } = useEntity<Entity>();

    return useAsync(async () => { 
        let value = findEntityChildren(entity, catalogApi, filter);
        //setFilteredEntityChildren( x => value );
        return value;
     }, [entity]);
}

